import { g as getCookie, s as setCookie } from "./utilities-2Suih3Nm.js";
class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.el = this;
    this.id = this.getAttribute("data-id");
    this.timerType = this.dataset.timerType;
    this._visible = false;
    this._io = null;
    this._lastValues = {};
  }
  connectedCallback() {
    this.rootEl = this.closest("[data-hide-countdown-when-end-of-timer]");
    this.hideCountdownWhenEndOfTimer = this.rootEl && JSON.parse(this.rootEl.dataset.hideCountdownWhenEndOfTimer);
    this.init();
  }
  disconnectedCallback() {
    var _a;
    clearInterval(this.intervalId);
    (_a = this._io) == null ? void 0 : _a.disconnect();
    this._io = null;
  }
  init() {
    this.MS_IN_SEC = 1e3;
    this.MS_IN_MIN = 60 * this.MS_IN_SEC;
    this.MS_IN_HRS = 60 * this.MS_IN_MIN;
    this.MS_IN_DAY = 24 * this.MS_IN_HRS;
    this.selectorMapping = {
      day: "[data-timer-day]",
      hour: "[data-timer-hour]",
      minute: "[data-timer-minute]",
      second: "[data-timer-second]"
    };
    this.units = ["day", "hour", "minute", "second"];
    this.shouldAddLeadingZero = true;
    this.timerType == "fixed_time" ? this.initCountDownFixedTime() : this.initCountDownEvergreen();
  }
  hideRootEl() {
    if (this.hideCountdownWhenEndOfTimer && this.rootEl && !(window.Shopify && window.Shopify.designMode)) {
      this.rootEl.classList.add("hidden");
    }
  }
  initCountDownFixedTime() {
    const countdownData = this.el.getAttribute("data-date-end");
    if (countdownData) {
      this.targetTime = new Date(countdownData).getTime();
    }
    if (!this.targetTime) {
      return;
    }
    this.startTime = Date.now();
    if (this.targetTime > this.startTime) {
      this.fetchDomElements();
      this._observeViewport();
      this.beginCountdown();
    } else {
      this.hideRootEl();
    }
  }
  initCountDownEvergreen() {
    this.evergreenDuration = this.dataset.evergreenDuration ? parseInt(this.dataset.evergreenDuration) : 0;
    this.cookieName = `evergreen_start_${this.id}`;
    this.cookieValue = getCookie(this.cookieName);
    if (this.cookieValue) {
      this.targetTime = new Date(Number(this.cookieValue)).getTime();
    } else {
      this.targetTime = Date.now() + this.evergreenDuration * this.MS_IN_HRS;
      setCookie(this.cookieName, this.targetTime);
    }
    this.startTime = Date.now();
    if (this.targetTime <= this.startTime) {
      this.targetTime = Date.now() + this.evergreenDuration * this.MS_IN_HRS;
      setCookie(this.cookieName, this.targetTime);
    }
    this.fetchDomElements();
    this._observeViewport();
    this.beginCountdown();
  }
  fetchDomElements() {
    this.elements = {};
    this.units.forEach((unit) => {
      this.elements[unit] = this.querySelector(this.selectorMapping[unit]).querySelector(".block-countdown-item-number .text-custom-content-inner");
    });
  }
  // ─── Viewport gating ──────────────────────────────────────────────
  _observeViewport() {
    this._io = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          this._visible = entry.isIntersecting;
          if (this._visible) this._flushDisplay();
        }
      },
      { rootMargin: "50px 0px" }
    );
    this._io.observe(this);
  }
  /** Write cached values to DOM when re-entering viewport */
  _flushDisplay() {
    if (!this._lastValues || !this.elements) return;
    this.units.forEach((unit) => {
      if (this.elements[unit] && this._lastValues[unit] != null) {
        this.elements[unit].textContent = this._lastValues[unit];
      }
    });
  }
  beginCountdown() {
    this.intervalId = setInterval(() => {
      const remainingTime = this.targetTime - Date.now();
      if (remainingTime <= 0) {
        this.terminateCountdown();
      } else {
        this.updateDisplay(remainingTime);
      }
    }, 1e3);
    this.el.classList.remove("hidden");
  }
  updateDisplay(remainingTime) {
    const timeComponents = this.computeTimeComponents(remainingTime);
    this.units.forEach((unit) => {
      if (this.elements[unit]) {
        const val = this.formatTimeComponent(timeComponents[unit]);
        this._lastValues[unit] = val;
        if (this._visible && this.elements[unit].textContent !== val) {
          this.elements[unit].textContent = val;
        }
      }
    });
  }
  computeTimeComponents(ms) {
    return {
      day: Math.floor(ms / this.MS_IN_DAY),
      hour: Math.floor(ms % this.MS_IN_DAY / this.MS_IN_HRS),
      minute: Math.floor(ms % this.MS_IN_HRS / this.MS_IN_MIN),
      second: Math.floor(ms % this.MS_IN_MIN / this.MS_IN_SEC)
    };
  }
  formatTimeComponent(value) {
    return this.shouldAddLeadingZero && value < 10 ? `0${value}` : value.toString();
  }
  terminateCountdown() {
    var _a;
    clearInterval(this.intervalId);
    (_a = this._io) == null ? void 0 : _a.disconnect();
    if (this.loop) {
      this.beginCountdown();
    } else {
      this.classList.add("hidden");
      this.hideRootEl();
    }
  }
  resetCountdown() {
    clearInterval(this.intervalId);
    this.units.forEach((unit) => {
      if (this.elements[unit]) {
        this.elements[unit].textContent = "00";
      }
    });
  }
}
if (!customElements.get("countdown-timer")) {
  customElements.define("countdown-timer", CountdownTimer);
}
